import React from 'react';

const Education = () => {
    return (
        <div className="bg-white py-10" id="education">
            <h2 className="text-4xl md:text-4xl text-center uppercase font-bold font-Kalam text-gray-800 pb-4 mt-10">
                <span className="underline underline-offset-3 decoration-3 decoration-black">Education</span>
            </h2>
            <div className="max-w-5xl mx-auto p-5">
                <div className="w-full shadow-md p-8 rounded-lg mb-10 bg-gray-800 text-white">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
                        <h3 className="text-2xl font-bold">Dr. Mahalingam College of Engineering and Technology</h3>
                        <span className="text-lg text-sky-400 font-medium">August 2019 - May 2023</span>
                    </div>
                    <div className="space-y-2">
                        <p className="text-xl">B.E , Computer Science and Engineering</p>
                        <p className="text-lg font-medium text-gray-300">CGPA - 8.3</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Education;
